var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading && !_vm.resultIsImage)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.result)}}):(!_vm.loading)?_c('img',{class:_vm.svgClass,attrs:{"src":_vm.src}}):_c('CLoadingDots',{staticClass:"text-gray-500 w-4"})}
var staticRenderFns = []

export { render, staticRenderFns }